var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFindSidebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.207,
    height: 19.474,
    viewBox: "0 0 21.207 19.474",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_220",
    "data-name": "Group 220",
    transform: "translate(-13.5 -102.147)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Light",
    transform: "translate(14 102.652)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Shape",
    d: "M0 5.232a6.956 6.956 0 1 1 .012 3.5",
    className: "prefix__cls-1",
    transform: "translate(2.824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Shape-2",
    d: "M0 0l5.97 5.969",
    className: "prefix__cls-1",
    "data-name": "Shape",
    transform: "translate(14.029 12.293)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Shape-3",
    d: "M0 2.363h4.967a.435.435 0 0 0 .376-.217L6.457.218a.435.435 0 0 1 .793.087l1.13 3.663a.435.435 0 0 0 .8.066l1.354-2.707a.435.435 0 0 1 .75-.047l.989 1.483a.435.435 0 0 0 .705.026l1.347-1.731",
    className: "prefix__cls-1",
    "data-name": "Shape",
    transform: "translate(0 4.595)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindSidebar);
export default __webpack_public_path__ + "static/media/find-sidebar.def195461e9305c4441350a12b71bbe9.svg";
export { ForwardRef as ReactComponent };